import { Private_Routes } from '@common/url';
import { theme } from '@prophecy/theme';
import { Button } from '@prophecy/ui-v3/Button';
import { Stack } from '@prophecy/ui-v3/Layout';
import { Text } from '@prophecy/ui-v3/Typography';

export interface BlockedReasonProps {
  isOutOfCredits: boolean;
  isAtBudgetLimit: boolean;
  teamName: string;
  isBillingAdmin: boolean;
  hasReplayMode: boolean;
  onNavigate: (url: string) => void;
}

export const BlockedReason = ({
  isOutOfCredits,
  isAtBudgetLimit,
  teamName,
  isBillingAdmin,
  hasReplayMode,
  onNavigate
}: BlockedReasonProps) => {
  const allowUpdateLimit = isBillingAdmin && !hasReplayMode;

  if (!isOutOfCredits && !isAtBudgetLimit) {
    return null;
  }

  if (isOutOfCredits) {
    return (
      <Stack direction='vertical' gap={theme.spaces.x6} padding={`${theme.spaces.x12} 0`}>
        <Text level='md'>Your team {teamName} has reached the monthly credit limit.</Text>
        {allowUpdateLimit ? (
          <Stack direction='horizontal' alignY='center' gap={theme.spaces.x4}>
            <Text level='md'>Please</Text>
            <Button
              variant='link'
              size='l'
              data-test-id='upgrade-to-pro-edition-button'
              onClick={() => {
                onNavigate(Private_Routes.Settings.tab.getUrl({ tab: 'usage&Billing' }));
              }}>
              upgrade
            </Button>
            <Text level='md'>your plan to use this feature.</Text>
          </Stack>
        ) : (
          <Text level='md'>Please contact your team admin to upgrade the plan to use this feature.</Text>
        )}
      </Stack>
    );
  }

  if (isAtBudgetLimit) {
    return (
      <Stack direction='vertical' gap={theme.spaces.x6} padding={`${theme.spaces.x12} 0`}>
        <Text level='md'>Your team {teamName} has reached the monthly budget limit.</Text>
        {allowUpdateLimit ? (
          <Stack direction='horizontal' alignY='center' gap={theme.spaces.x4}>
            <Text level='md'>Please increase your </Text>
            <Button
              variant='link'
              size='l'
              data-test-id='increase-budget-limit-button'
              onClick={() => {
                onNavigate(Private_Routes.Settings.tab.getUrl({ tab: 'usage&Billing' }));
              }}>
              monthly budget limit
            </Button>
            <Text level='md'>to use this feature.</Text>
          </Stack>
        ) : (
          <Text level='md'>
            Please contact your team admin to increase the monthly budget limit to use this feature.
          </Text>
        )}
      </Stack>
    );
  }
};
